<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<!-- <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button> -->
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="门店" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="手机" min-width="120" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.mobile }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="提现金额" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.money }}
				  </template>
				</el-table-column>
				<el-table-column label="到账金额" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.dz_money }}
				  </template>
				</el-table-column>
				<el-table-column label="手续费" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.cost }}
				  </template>
				</el-table-column>
				<el-table-column label="类型" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.type_name }}
				  </template>
				</el-table-column>
				<el-table-column label="提现银行" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.bank_name }}
				  </template>
				</el-table-column>
				<el-table-column label="开户银行" min-width="130" align="center">
				  <template slot-scope="scope">
					{{ scope.row.account_bank }}
				  </template>
				</el-table-column>
				<el-table-column label="账户名称" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.account_name }}
				  </template>
				</el-table-column>
				<el-table-column label="账号" min-width="120" align="center">
				  <template slot-scope="scope">
					{{ scope.row.account }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="warning">待审核</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="success">已审核</el-tag>
					<el-tag v-if="scope.row.status === 3" size="mini" type="info">已完成</el-tag>
					<el-tag v-if="scope.row.status === 4" size="mini" type="danger">驳回</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="180">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="审核" placement="top" v-if="scope.row.status <= 2">
					  <el-button type="warning" icon="el-icon-setting" size="mini" circle @click="handleOperate(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 弹框 -->
		<el-dialog :visible.sync="operate" width="50%" :close-on-click-modal="false" append-to-body :title="title">
			<el-form ref="operate_form" :model="operate_form" label-width="120px">
				<el-form-item>
					<el-radio-group v-model="operate_form.status" size="medium">
						<!-- <el-radio :label="1" border>待审核</el-radio> -->
						<el-radio :label="2">已审核</el-radio>
						<el-radio :label="3">已完成</el-radio>
						<el-radio :label="4">驳回</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
			  <el-button size="mini" @click="operate = false">取 消</el-button>
			  <el-button type="primary" size="mini" @click="operateSubmit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'tocash',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					username:'',
					password:'',
					mobile:'',
					role_ids:[],
					status:1,
					avatar:'',
					url:'',
				},
				rules:{
					username: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					role_ids: [
					  { required: true, message: '请选择角色', trigger: ['blur', 'change'] }
					],
				},
				operate:false,
				operate_form:{
					id:'',
					status:'',
				},
			}
		},
		mounted() {
			
		},
		methods:{
			handleOperate(row){
				this.title = '审核'
				this.operate_form.id = row.id
				this.operate_form.status = row.status
				this.operate = true
			},
			operateSubmit(){
				if(this.operate_form.status == ''){
					this.$message.error('先选择状态')
					return false
				}
				this.axios.post('/manage/tocash/operate',this.operate_form).then(res=>{
					if(res.status){
						this.getList()
						this.$message.success('审核成功')
						this.operate = false
					}else{
						this.$message.error('审核失败')
					}
				})
			},
		}
	}
</script>

<style>
</style>